import { Validators } from '@angular/forms';
import {
  CancerHistoryStatus,
  InVitroTypes,
  ValidationPair,
} from '@app/modules/service-data/types/service-data.types';
import { gestationAgeValidValidator } from '@app/modules/service-data/validators/gestation-age-valid.validator';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';
import { diseasesValidator } from '@shared/validators/diseases-validator';
import { errorValueValidator } from '@shared/validators/error-value-validator';

export const carrierValidationSet: ValidationPair = {
  children: {
    carrier: {
      children: {
        patientHistory: {
          children: {
            cysticFibrosisHistory: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator(true)],
            },
          },
        },
      },
    },
    shared: {
      children: {
        currentPregnancyInformation: {
          children: {
            inVitro: {
              children: {
                vitroType: {
                  validators: [errorValueValidator(InVitroTypes.DonorEgg)],
                },
              },
            },
          },
        },
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            cancerHistory: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
                status: {
                  validators: [
                    errorValueValidator(CancerHistoryStatus.CurrentlyAffected),
                  ],
                },
              },
            },
            stemCellTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            transplantSurgery: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            bloodTransfusion: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
            chromosomalAbnormalityCarrier: {
              children: {
                isCarrier: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            carrierOfGeneticDiseases: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator()],
            },
          },
        },
      },
      validators: [
        gestationAgeValidValidator(),
        crossFieldValidator(
          'patientHistory.cancerHistory.status',
          'patientHistory.cancerHistory.hasHistory',
          true
        ),
        crossFieldValidator(
          'patientHistory.bloodTransfusion.isRelevant',
          'patientHistory.bloodTransfusion.hasReceived',
          true
        ),
      ],
    },
  },
};
